// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-box-shadow {
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
}

.spacer {
  flex: 1 1 auto;
}

.toolbar-homologacao {
  background-color: #F58634;
  color: #000;
  height: 50px;
}

.toolbar-i7code {
  background-color:#10ACA0;
  color: #000;
  height: 50px;
}

.toolbar-idba {
  background-color: #00a19a;
  color: #000;
  height: 50px;
}

.toolbar-producao-idba {
  background-color: #005490;
  color: #000;
  height: 50px;
}

.toolbar-producao-tiberio {
  background-color: #d72e10;
  color: #000;
  height: 50px;
}

.toolbar-producao-menegon {
  background-color: #d72e10;
  color: #000;
  height: 50px;
}

.toolbar-producao-tiberio {
  background-color: #115c3b;
  color: #000;
  height: 50px;
}

.toolbar-producao-2cloud {
  background-color: #9182BD;
  color: #000;
  height: 50px;
}

.white-icon {
  color: white;
}

.avatar {
  height: 35px; 
  top: 0px; 
  vertical-align: sub !important;
}

.ml-2
{
  top: 0px !important;
  vertical-align: super !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/header/header.component.css"],"names":[],"mappings":"AAAA;EACE;sEACoE;AACtE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,8BAA8B;AAChC;;AAEA;;EAEE,mBAAmB;EACnB,gCAAgC;AAClC","sourcesContent":[".header-box-shadow {\r\n  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),\r\n    0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.spacer {\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.toolbar-homologacao {\r\n  background-color: #F58634;\r\n  color: #000;\r\n  height: 50px;\r\n}\r\n\r\n.toolbar-i7code {\r\n  background-color:#10ACA0;\r\n  color: #000;\r\n  height: 50px;\r\n}\r\n\r\n.toolbar-idba {\r\n  background-color: #00a19a;\r\n  color: #000;\r\n  height: 50px;\r\n}\r\n\r\n.toolbar-producao-idba {\r\n  background-color: #005490;\r\n  color: #000;\r\n  height: 50px;\r\n}\r\n\r\n.toolbar-producao-tiberio {\r\n  background-color: #d72e10;\r\n  color: #000;\r\n  height: 50px;\r\n}\r\n\r\n.toolbar-producao-menegon {\r\n  background-color: #d72e10;\r\n  color: #000;\r\n  height: 50px;\r\n}\r\n\r\n.toolbar-producao-tiberio {\r\n  background-color: #115c3b;\r\n  color: #000;\r\n  height: 50px;\r\n}\r\n\r\n.toolbar-producao-2cloud {\r\n  background-color: #9182BD;\r\n  color: #000;\r\n  height: 50px;\r\n}\r\n\r\n.white-icon {\r\n  color: white;\r\n}\r\n\r\n.avatar {\r\n  height: 35px; \r\n  top: 0px; \r\n  vertical-align: sub !important;\r\n}\r\n\r\n.ml-2\r\n{\r\n  top: 0px !important;\r\n  vertical-align: super !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
